export const API_BASE_URL = "https://api.uyirmozhy.in";
export const IMG_BASE_URL = "https://api.uyirmozhy.in/assets/images/";